// Color Constants
export const C = {
  black: '#090A0B',
  dark2: '#0D1117',
  dark3: '#070A12',
  primary: '#004AAD',
  secondary: '#0082FB',
  accent: '#00B4FF',
  white: '#FFFFFF',
  g300: '#B0B8C4',
  g400: '#6B7A8D',
  grad: 'linear-gradient(135deg, #004AAD 0%, #0082FB 100%)',
  gradW: 'linear-gradient(135deg, #004AAD 0%, #0082FB 50%, #00B4FF 100%)',
  neon: '0 0 20px rgba(0,130,251,0.3), 0 0 60px rgba(0,74,173,0.15)',
  neonS: '0 0 30px rgba(0,130,251,0.5), 0 0 80px rgba(0,74,173,0.25)',
  red: '#FF4D4D',
  green: '#00D68F',
  yellow: '#FFB800'
};

// Font Family
export const F = "'Sansation', sans-serif";

// AI-Generated Images
export const IMAGES = {
  heroBackground: 'https://static.prod-images.emergentagent.com/jobs/597dd702-7f0f-44a1-9430-589c930619e7/images/dd5f2f1a24d71c4d80ebc7652ab67209e5a76e5e2166365515b3fcbb01a099ac.png',
  dashboardIntelligence: 'https://static.prod-images.emergentagent.com/jobs/597dd702-7f0f-44a1-9430-589c930619e7/images/5cf33b805fc88f087a810d4163fe57686780b860a43c572e1ee28d9044d2540e.png',
  deckAnalysis: 'https://static.prod-images.emergentagent.com/jobs/597dd702-7f0f-44a1-9430-589c930619e7/images/1a0dcbc3acc2b8563eb69bf04f8083a5e83b587fce1b384366686c680eda15db.png',
  teamCollaboration: 'https://static.prod-images.emergentagent.com/jobs/597dd702-7f0f-44a1-9430-589c930619e7/images/b968bd5ddfe9dd1fb097d5569b36f73d8515a6fd710c49df7e1ae0c551bf0916.png'
};